// @flow
export { default } from './BrandCard';



// WEBPACK FOOTER //
// ./src/components/common/BrandCard/index.js